module.exports = __webpack_public_path__ + "media/images/icons/file_arrow_up-ee9ffa64bf2ab636860870933c6ef9e1.svg";